import React from "react";
import { Check, X } from "lucide-react";
import { COMPARISON } from "../../mock/mockData";

const Comparison = () => {
  return (
    <section id="comparativo" className="border-t-[3px] border-black bg-white">
      <div className="max-w-[1440px] mx-auto px-5 md:px-10 py-16 md:py-24">
        <div className="mb-12">
          <div className="flex items-center gap-3 mb-5">
            <span className="mono text-[11px] uppercase tracking-widest px-3 py-1 brut-border bg-white">04</span>
            <span className="mono text-[11px] uppercase tracking-widest text-black/60">Lítio vs Chumbo — Comparativo</span>
            <div className="flex-1 h-[3px] bg-black" />
          </div>
          <h2 className="display font-bold text-[36px] sm:text-[56px] md:text-[80px] lg:text-[96px] leading-[0.9]">
            Cada linha é uma
            <br />
            <span className="italic font-normal">objecção</span> que
            <br />
            desaparece.
          </h2>
        </div>

        <div className="grid lg:grid-cols-2 gap-6 lg:gap-8">
          {/* Chumbo */}
          <div className="brut-border bg-[#F4F0E8] relative">
            <div className="px-6 py-4 bg-black text-white border-b-[3px] border-black flex items-center justify-between">
              <span className="mono text-[11px] uppercase tracking-widest font-bold">{COMPARISON.chumbo.badge}</span>
              <span className="mono text-[10px] uppercase tracking-widest text-white/60">Concorrência</span>
            </div>
            <div className="p-6 md:p-8">
              <h3 className="display text-[26px] md:text-[32px] font-bold leading-tight mb-6">{COMPARISON.chumbo.title}.</h3>
              <ul className="space-y-3">
                {COMPARISON.chumbo.items.map((it, i) => (
                  <li key={i} className="flex items-start gap-3 text-[14px] leading-[1.5]">
                    <span className="w-5 h-5 mt-0.5 brut-border bg-white flex items-center justify-center flex-shrink-0">
                      <X size={14} strokeWidth={3} />
                    </span>
                    <span dangerouslySetInnerHTML={{ __html: it }} />
                  </li>
                ))}
              </ul>
              <div className="mt-8 brut-border bg-white p-5 inline-flex flex-col">
                <span className="display text-[44px] font-bold leading-none">{COMPARISON.chumbo.highlight}</span>
                <span className="mono text-[11px] uppercase tracking-widest text-black/70 mt-2">{COMPARISON.chumbo.highlightLabel}</span>
              </div>
            </div>
          </div>

          {/* Litio */}
          <div className="brut-border bg-[#E63946] text-white relative brut-shadow-yellow">
            <div className="px-6 py-4 bg-[#FFD60A] text-black border-b-[3px] border-black flex items-center justify-between">
              <span className="mono text-[11px] uppercase tracking-widest font-bold">{COMPARISON.litio.badge}</span>
              <span className="mono text-[10px] uppercase tracking-widest text-black/70">Veentto</span>
            </div>
            <div className="p-6 md:p-8">
              <h3 className="display text-[26px] md:text-[32px] font-bold leading-tight mb-6">{COMPARISON.litio.title}.</h3>
              <ul className="space-y-3">
                {COMPARISON.litio.items.map((it, i) => (
                  <li key={i} className="flex items-start gap-3 text-[14px] leading-[1.5]">
                    <span className="w-5 h-5 mt-0.5 brut-border bg-[#FFD60A] text-black flex items-center justify-center flex-shrink-0">
                      <Check size={14} strokeWidth={3} />
                    </span>
                    <span dangerouslySetInnerHTML={{ __html: it }} />
                  </li>
                ))}
              </ul>
              <div className="mt-8 brut-border bg-black text-[#FFD60A] p-5 inline-flex flex-col">
                <span className="display text-[44px] font-bold leading-none">{COMPARISON.litio.highlight}</span>
                <span className="mono text-[11px] uppercase tracking-widest text-[#FFD60A]/70 mt-2">{COMPARISON.litio.highlightLabel}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Comparison;
